<template>
  <!-- Not logged in toolbar-->
  <v-toolbar app dense color="primary" v-if="!loggedIn" class="nav" role="navigation">
    <template v-if="$vuetify.breakpoint.smAndDown">
      <img :src="`${getLogoUrl}`" class="institute-logo" :alt="$t('university_logo')" />
      <v-spacer/>
      <language-menu :bg-col="this.hexToRGBA(this.$vuetify.theme.primary)"/>
    </template>
    <v-flex v-if="$vuetify.breakpoint.mdAndUp">
      <v-container class="py-0">
        <v-layout row class="navBar__center">
          <img :src="`${getLogoUrl}`" class="institute-logo" :alt="$t('university_logo')">
          <v-spacer/>
          <language-menu :bg-col="this.hexToRGBA(this.$vuetify.theme.primary)"/>
        </v-layout>
      </v-container>
    </v-flex>
  </v-toolbar>
  <!-- Logged in toolbar for mobile/desktop-->
  <v-toolbar app dense color="primary" v-else class="nav" role="navigation">
    <v-menu attach v-if="$vuetify.breakpoint.smAndDown" offset-y transition="scale-transition">
      <v-btn icon slot="activator">
        <v-icon class="primary-text">menu</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile v-for="nav in navs" :key="nav.id" :to="nav.destination? {name:nav.destination}: null">
          <v-list-tile-content>
            <v-list-tile-title>
              {{getTranslatedMenu(nav.text)}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-flex v-if="$vuetify.breakpoint.mdAndUp">
      <v-container class="py-0">
        <v-layout row class="nav-desktop">
          <img :src="`${getLogoUrl}`" class="institute-logo pointer" @click="goDesktop" :alt="$t('university_logo')">
          <v-btn v-for="nav in navs" :key="nav.id" flat :id="`menu_${nav.id}`"
                 :to="nav.destination? {name:nav.destination}: null" class="nav-btn">
            <span :style="textColor">{{getTranslatedMenu(nav.text)}}</span>
          </v-btn>
          <v-spacer/>
          <accessibility-switch class="pt-2" v-if="isStudent"/>
          <last-updated-date/>
          <announcement-icon/>
          <personal-menu/>
        </v-layout>
      </v-container>
    </v-flex>
    <img :src="`${getLogoUrl}`" v-if="$vuetify.breakpoint.smAndDown" class="institute-logo" :style="logoStyling"
         @click="goDesktop" :alt="$t('university_logo')" />
    <v-spacer v-if="$vuetify.breakpoint.smAndDown"/>
    <accessibility-switch v-if="isStudent && $vuetify.breakpoint.smAndDown"/>
    <last-updated-date v-if="$vuetify.breakpoint.smAndDown"/>
    <announcement-icon v-if="$vuetify.breakpoint.smAndDown"/>
    <personal-menu v-if="$vuetify.breakpoint.smAndDown"/>
  </v-toolbar>
</template>

<script>
  import PersonalMenu from './PersonalMenu'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { LOGOUT } from '../../store/action-types'
  import { HAS_FEATURE_FLAG, IS_ADMIN, IS_STUDENT, GET_LOGO_TYPE, GET_LOGO_URL } from '../../store/getter-types'
  import Colors from '../../mixins/Colors'
  import AnnouncementIcon from '../announcement/AnnouncementIcon'
  import LastUpdatedDate from './LastUpdatedDate'
  import AccessibilitySwitch from './AccessibilitySwitch'
  import LanguageMenu from './LanguageMenu'

  const staffMenu = [
    {
      id: 'dashboard',
      destination: 'Dashboard',
      text: 'menu_dashboard'
    },
    {
      id: 'my_students',
      destination: 'Students',
      text: 'menu_my_students'
    },
    {
      id: 'menu_interactions',
      destination: 'Interactions',
      text: 'menu_intervention'
    },
    {
      id: 'insights',
      destination: 'Insights',
      text: 'menu_insights'
    }
  ]
  const adminMenu = [
    {
      id: 'feeds',
      destination: 'DailyFeeds',
      text: 'menu_feeds'
    },
    {
      id: 'config',
      destination: 'AdminConfig',
      text: 'menu_config'
    }
  ]

  const studentMenu = [
    {
      id: 'menu_student_profile',
      destination: 'StudentHome',
      text: 'menu_student_profile'
    }
  ]

  const helpItem = [
    {
      id: 'help',
      destination: 'Help',
      text: 'help.link'
    }
  ]

  export default {
    components: {LastUpdatedDate, AnnouncementIcon, PersonalMenu, AccessibilitySwitch, LanguageMenu},
    name: 'main-toolbar',
    mixins: [Colors],
    methods: {
      getTranslatedMenu (text) {
        return this.$t(text)
      },
      goDesktop () {
        this.$router.push('/goHome')
      },
      ...mapActions({
        'setLanguageFromDescription': 'setLanguageFromDescription',
        doLogout: LOGOUT
      }),
      hexToRGBA (hex) {
        let r = parseInt(hex.slice(1, 3), 16)
        let g = parseInt(hex.slice(3, 5), 16)
        let b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r},${g},${b},100)`
      }
    },
    computed: {
      ...mapGetters({
        isStudent: IS_STUDENT,
        isAdmin: IS_ADMIN,
        hasFeatureFlag: HAS_FEATURE_FLAG,
        getLogoType: GET_LOGO_TYPE,
        getLogoUrl: GET_LOGO_URL
      }),
      ...mapState({
        loggedIn: state => state.profile.loggedIn,
        moduleInterExem: state => state.profile.module.interexem,
        moduleInsights: state => state.profile.module.insights,
        functionHeaderMenu: state => state.profile.functions.headerMenu,
        enableInsightsForStaff: state => state.profile.options.enable.insightsForStaff,
        optionEnableInteractions: state => state.profile.options.enable.interactions,
        modConfigMenu: state => state.profile.module.config,
        functionConfigMenu: state => state.profile.functions.adminMenu,
        optionConfigMenu: state => state.profile.options.enable.config,
        functionAcademic: state => state.configUI.functions.academic,
        functionIntervention: state => state.configUI.functions.intervention,
        functionExemption: state => state.configUI.functions.exemption,
        optionEnableAcademic: state => state.configUI.options.enable.academic,
        optionEnableIntervention: state => state.configUI.options.enable.intervention,
        optionEnableExemption: state => state.configUI.options.enable.exemption
      }),
      logoStyling () {
        if (this.$vuetify.breakpoint.xsOnly) {
          return {maxWidth: '100px'}
        }
      },
      textColor () {
        return {color: this.getTextColor(this.$vuetify.theme.primary)}
      },
      navs () {
        let key = this.isAdmin ? 'admin' : (this.isStudent ? 'student' : 'staff')
        return {
          'staff': this.buildStaffMenu.concat(helpItem),
          'admin': this.buildAdminMenu,
          'student': studentMenu.concat(helpItem)
        }[key]
      },
      buildStaffMenuForAdmin () {
        return !this.flagEnableInteractions
          ? staffMenu.filter(el => el.destination !== 'Interactions')
          : staffMenu
      },
      buildStaffMenu () {
        let menu = this.buildStaffMenuForAdmin
        menu = !this.flagEnableInsights
          ? menu.filter(el => el.destination !== 'Insights')
          : menu
        return menu
      },
      buildAdminMenu () {
        if (!this.checkConfigItems) {
          return this.buildStaffMenuForAdmin.concat(adminMenu, helpItem).filter(el => el.destination !== 'AdminConfig')
        } else if (!this.flagEnableConfigMenu) {
          return this.buildStaffMenuForAdmin.concat(adminMenu, helpItem).filter(el => el.destination !== 'AdminConfig')
        } else {
          return this.buildStaffMenuForAdmin.concat(adminMenu, helpItem)
        }
      },
      flagEnableInsights () {
        return this.hasFeatureFlag(this.moduleInsights + '.' + this.functionHeaderMenu + '.' + this.enableInsightsForStaff)
      },
      flagEnableInteractions () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionHeaderMenu + '.' + this.optionEnableInteractions)
      },
      flagEnableConfigMenu () {
        return this.hasFeatureFlag(this.modConfigMenu + '.' + this.functionConfigMenu + '.' + this.optionConfigMenu)
      },
      checkConfigItems () {
        return this.hasFeatureFlag(this.modConfigMenu + '.' + this.functionAcademic + '.' + this.optionEnableAcademic) ||
          this.hasFeatureFlag(this.modConfigMenu + '.' + this.functionIntervention + '.' + this.optionEnableIntervention) ||
          this.hasFeatureFlag(this.modConfigMenu + '.' + this.functionExemption + '.' + this.optionEnableExemption)
      }
    }
  }
</script>

<style scoped>
  .nav {
    z-index: 4;
    position: fixed;
  }

  .navBar__center {
    align-items: center;
  }
  .nav-btn {
    min-width: 50px
  }

  .nav-desktop {
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/MainToolbar.vue